import { ColumnMetadataModel } from '@tailormap-viewer/api';

export interface FeatureInfoColumnMetadataModel extends ColumnMetadataModel {
  layerId: string;
}
